// PROMPT 12B — shared external-referral status labels + colors (external portal + staff pages).
export const NAVY = "#1C4358", RED = "#9C1E22", GREEN = "#2F7D5A", AMBER = "#B7791F",
  SKY = "#2C6480", BLUE = "#2563EB", GRAY = "#6B7280";

export const REF_STATUS_HEX = {
  draft: GRAY, sent: SKY, viewed: BLUE, accepted: GREEN, declined: RED,
  appointment_pending: AMBER, appointment_completed: GREEN,
  tour_pending: AMBER, tour_completed: GREEN,
  quote_pending: AMBER, quote_uploaded: BLUE,
  in_progress: BLUE, completed: GREEN, cancelled: GRAY, follow_up_needed: AMBER,
};

export const pretty = (s) =>
  String(s == null ? "" : s).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const hexA = (hex, a) => {
  const h = (hex || GRAY).replace("#", "");
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${a})`;
};

export const fmtDate = (v) => {
  if (!v) return "";
  try { return new Date(v).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }); }
  catch { return String(v); }
};

export const PRIORITY_HEX = { low: GRAY, normal: SKY, high: AMBER, urgent: RED };
